"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datadogBrowser = void 0;
var integrations_1 = require("./integrations");
Object.defineProperty(exports, "datadogBrowser", { enumerable: true, get: function () { return integrations_1.datadogBrowser; } });
//# sourceMappingURL=index.js.map